import { Component, OnInit, Output, Input, ViewChild } from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import { T2CardComponent } from '../../../../../../trip2-theme/components/t2-card/t2-card.component';
import { NatureService } from './../../../../../../services/administration/nature.service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

@Component({
  selector: 'app-manage-nature',
  templateUrl: './manage-nature.component.html',
  styleUrls: ['./manage-nature.component.scss']
})
export class ManageNatureComponent implements OnInit {

  data: any = {};
  title = 'Add new Nature';
  @Input() dateSelected?: any;
  @Output() cancel?: EventEmitter <boolean> = new EventEmitter <boolean>();
  @ViewChild('appCreate') card: T2CardComponent;

  constructor(
    private natureService: NatureService,
    private sweetAlertHelper: SweetAlertHelper,
    ) { }

  ngOnInit() {
    if (this.dateSelected) {
      this.data = this.dateSelected;
      this.title = 'Edit Nature - ' + this.data.description;
    }else {
      this.title = 'Add new Nature';
    }
  }

  cancelCreateEdit() {
    this.cancel.emit(false);
    this.data = {};
  }

  saveAction() {
    if (!this.dateSelected) {
      this.natureService.store(this.data).finally(() => {
        this.card.viewProgressBar(false);
      }).subscribe(
        (response: any) => {
          if(response.success) {
            this.sweetAlertHelper.createCustomAlert({ title: 'Success', type: 'success', text: response.message}).then(() => this.cancelCreateEdit());
          } else {
            this.sweetAlertHelper.createCustomAlert({ title: 'Error', type: 'error', text: response});
          }
        }
      );
    }else {
      this.natureService.update(this.data).finally(() => {
        this.card.viewProgressBar(false);
      }).subscribe(
        (response: any) => {
          if(response.success) {
            this.sweetAlertHelper.createCustomAlert({ title: 'Success', type: 'success', text: response.message}).then(() => this.cancelCreateEdit());
          } else {
            this.sweetAlertHelper.createCustomAlert({ title: 'Error', type: 'error', text: response});
          }
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/administration/reservations/nature/components/manage-nature/manage-nature.component.ts